export default __webpack_public_path__ + "static/media/yogesh_kumar.fe60208f.pdf";